import { render, staticRenderFns } from "./VerificationLogin.vue?vue&type=template&id=768187ba&scoped=true&"
import script from "./VerificationLogin.vue?vue&type=script&lang=js&"
export * from "./VerificationLogin.vue?vue&type=script&lang=js&"
import style0 from "./VerificationLogin.vue?vue&type=style&index=0&id=768187ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768187ba",
  null
  
)

export default component.exports